export type PaginationOptions = {
  currentIndex: number;
  siblingCount?: number;
  withEllipsis?: boolean;
} & (
  | {
      validPages: ReadonlySet<number>;
    }
  | {
      totalPages: number;
    }
);

export function getPagination(options: PaginationOptions): number[] {
  const { currentIndex, siblingCount = 1, withEllipsis = true } = options;

  const validPages =
    "validPages" in options
      ? options.validPages
      : new Set(
          Array.from({ length: options.totalPages }, (_, index) => index),
        );

  if (validPages.size === 0 || !withEllipsis) {
    return [...validPages];
  }

  const sorted = [...validPages].sort((a, b) => a - b);

  const set = new Set<number>();

  const first = sorted[0];
  const last = sorted[sorted.length - 1];

  set.add(first);
  set.add(last);

  for (const page of sorted) {
    if (Math.abs(page - currentIndex) <= siblingCount) {
      set.add(page);
    }
  }

  const pages = [...set].sort((a, b) => a - b);

  const result: number[] = [];
  let prev: number | null = null;

  for (const page of pages) {
    if (prev !== null) {
      const gap = page - prev;

      if (gap > 1) {
        result.push(-1);
      }
    }

    result.push(page);
    prev = page;
  }

  return result;
}
